"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const ports_1 = require("@/store/ducks/ports");
const ports_2 = require("@/services/ports");
const listPortsUseCase_1 = __importDefault(require("./listPortsUseCase"));
function createPortsUseCase(countryId, portsNames) {
    return async (dispatch) => {
        dispatch((0, ports_1.createPort)());
        try {
            const createPortsPromise = portsNames.map((name) => {
                return (0, ports_2.createPort)({ name, countryId });
            });
            const response = await Promise.allSettled(createPortsPromise);
            if (response.some((response) => response.status === "rejected")) {
                dispatch((0, ports_1.createPortError)());
                dispatch((0, ports_1.openPortsToast)({
                    status: "error",
                    message: "There was an error while creating the port",
                }));
                return;
            }
            await (0, listPortsUseCase_1.default)()(dispatch).then(() => {
                dispatch((0, ports_1.filterPortsByCountry)(countryId));
                dispatch((0, ports_1.onHideSavePrompt)());
                dispatch((0, ports_1.createPortSuccess)());
                dispatch((0, ports_1.openPortsToast)({
                    status: "success",
                    message: "Port created successfully",
                }));
            });
        }
        catch (error) {
            dispatch((0, ports_1.createPortError)());
            dispatch((0, ports_1.openPortsToast)({
                status: "error",
                message: "There was an error while creating the port",
            }));
        }
    };
}
exports.default = createPortsUseCase;
